/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TasksInputs */

const cs_nav_tasks = /** @type {(inputs: Nav_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkoly`)
};

const en_nav_tasks = /** @type {(inputs: Nav_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Nav_TasksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_tasks = /** @type {((inputs?: Nav_TasksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TasksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_tasks(inputs)
	return cs_nav_tasks(inputs)
});